import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@node-space/hooks'
import AppLoader from 'components/AppLoader'
import { PathNames } from 'constants/General'
import { ExternalLinks } from 'constants/links'
import { useAuthenticatedPathRedirect } from 'hooks/useAuthenticatedPathRedirect'
import {
  OnboardingVerificationStatuses,
  RejectedVerificationStatuses,
  VerificationRequestStatus,
} from 'types/verification'
import { performAuthRedirect } from 'utils/auth/utils'

export interface AuthenticateProps {
  isLoadingData: boolean
  verificationRequestStatus: VerificationRequestStatus
}

export const Authenticate = ({ isLoadingData, verificationRequestStatus }) => {
  const navigate = useNavigate()
  const { isAuthed } = useAuth()
  const { redirectToLanding } = useAuthenticatedPathRedirect()

  useEffect(() => {
    if (isLoadingData) return

    if (!isAuthed) {
      navigate(PathNames.LOGOUT, { replace: true })
      return
    }

    if (RejectedVerificationStatuses.includes(verificationRequestStatus)) {
      navigate(PathNames.APPLICATION_UNSUCCESSFUL, { replace: true })
      return
    }

    if (OnboardingVerificationStatuses.includes(verificationRequestStatus)) {
      performAuthRedirect(ExternalLinks.ONBOARDING)
      return
    }

    redirectToLanding()
  }, [isAuthed, isLoadingData, verificationRequestStatus])

  return <AppLoader />
}
